var _excluded = ["column", "value"],
  _excluded2 = ["selectedValues"],
  _excluded3 = ["selectedValues"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GridUtils } from '@deephaven/grid';
import { DateUtils, TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { assertNotNull, bindAllMethods, EMPTY_ARRAY, EMPTY_MAP, isNotNullOrUndefined } from '@deephaven/utils';
import AggregationUtils from "./sidebar/aggregations/AggregationUtils.js";
import AggregationOperation from "./sidebar/aggregations/AggregationOperation.js";
import { FormatterType } from "./sidebar/conditional-formatting/ConditionalFormattingUtils.js";
import AdvancedSettings from "./sidebar/AdvancedSettings.js";
import ColumnHeaderGroup from "./ColumnHeaderGroup.js";
import { isPartitionedGridModelProvider } from "./PartitionedGridModel.js";
var log = Log.module('IrisGridUtils');

/** @deprecated Use `DehydratedSort` instead */

export function isPanelStateV1(state) {
  return state.partition !== undefined;
}
export function isPanelStateV2(state) {
  return Array.isArray(state.partitions);
}

/**
 * Checks if an index is valid for the given array
 * @param x The index to check
 * @param array The array
 * @returns True if the index if valid within the array
 */
function isValidIndex(x, array) {
  return x >= 0 && x < array.length;
}
function isDateWrapper(value) {
  return (value === null || value === void 0 ? void 0 : value.asDate) != null;
}
class IrisGridUtils {
  /**
   * Exports the state from Grid component to a JSON stringifiable object.
   * See IrisGridCacheUtil for memoization and comparing dehydrated states.
   * @param model The table model to export the Grid state for
   * @param gridState The state of the Grid to export
   * @returns An object that can be stringified and imported with {{@link hydrateGridState}}
   */
  static dehydrateGridState(model, gridState) {
    var isStuckToBottom = gridState.isStuckToBottom,
      isStuckToRight = gridState.isStuckToRight,
      movedColumns = gridState.movedColumns,
      movedRows = gridState.movedRows;
    var columns = model.columns;
    return {
      isStuckToBottom,
      isStuckToRight,
      movedColumns: [...movedColumns].filter(_ref => {
        var to = _ref.to,
          from = _ref.from;
        return isValidIndex(to, columns) && (typeof from === 'number' && isValidIndex(from, columns) || Array.isArray(from) && isValidIndex(from[0], columns) && isValidIndex(from[1], columns));
      }).map(_ref2 => {
        var to = _ref2.to,
          from = _ref2.from;
        return {
          to: columns[to].name,
          from: Array.isArray(from) ? [columns[from[0]].name, columns[from[1]].name] : columns[from].name
        };
      }),
      movedRows: [...movedRows]
    };
  }

  /**
   * Import a state for Grid that was exported with {{@link dehydrateGridState}}
   * @param model The table model to import the state for
   * @param gridState The state of the panel that was saved
   * @returns The gridState props to set on the Grid
   */
  static hydrateGridState(model, gridState) {
    var customColumns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var isStuckToBottom = gridState.isStuckToBottom,
      isStuckToRight = gridState.isStuckToRight,
      movedColumns = gridState.movedColumns,
      movedRows = gridState.movedRows;
    var columns = model.columns;
    var customColumnNames = IrisGridUtils.parseCustomColumnNames(customColumns);
    var columnNames = columns.map(_ref3 => {
      var name = _ref3.name;
      return name;
    }).concat(customColumnNames);
    return {
      isStuckToBottom,
      isStuckToRight,
      movedColumns: [...movedColumns].map(_ref4 => {
        var to = _ref4.to,
          from = _ref4.from;
        var getIndex = x => typeof x === 'string' ? columnNames.findIndex(name => name === x) : x;
        return {
          to: getIndex(to),
          from: Array.isArray(from) ? [getIndex(from[0]), getIndex(from[1])] : getIndex(from)
        };
      }).filter(_ref5 => {
        var to = _ref5.to,
          from = _ref5.from;
        return isValidIndex(to, columnNames) && (typeof from === 'number' && isValidIndex(from, columnNames) || Array.isArray(from) && isValidIndex(from[0], columnNames) && isValidIndex(from[1], columnNames));
      }),
      movedRows: [...movedRows]
    };
  }

  /**
   * Export the IrisGridPanel state.
   * @param model The table model the state is being dehydrated with
   * @param irisGridPanelState The current IrisGridPanel state
   * @returns The dehydrated IrisGridPanel state
   */
  static dehydrateIrisGridPanelState(model, irisGridPanelState) {
    var isSelectingPartition = irisGridPanelState.isSelectingPartition,
      partitions = irisGridPanelState.partitions,
      advancedSettings = irisGridPanelState.advancedSettings;

    // Return value will be serialized, should not contain undefined
    return {
      isSelectingPartition,
      partitions,
      advancedSettings: [...advancedSettings]
    };
  }

  /**
   * Import the saved IrisGridPanel state.
   * @param model The model the state is being hydrated with
   * @param irisGridPanelState Exported IrisGridPanel state
   * @returns The state to apply to the IrisGridPanel
   */
  static hydrateIrisGridPanelState(model, irisGridPanelState) {
    var isSelectingPartition = irisGridPanelState.isSelectingPartition,
      advancedSettings = irisGridPanelState.advancedSettings;
    var partitions = [];
    if (isPanelStateV2(irisGridPanelState)) {
      partitions = irisGridPanelState.partitions;
    } else if (irisGridPanelState.partition != null) {
      partitions = [irisGridPanelState.partition];
    }
    return {
      isSelectingPartition,
      partitions,
      advancedSettings: new Map([...AdvancedSettings.DEFAULTS, ...advancedSettings])
    };
  }

  /**
   * Export the quick filters to JSON striginfiable object
   * @param quickFilters The quick filters to dehydrate
   * @returns The dehydrated quick filters
   */
  static dehydrateQuickFilters(quickFilters) {
    return [...quickFilters].map(_ref6 => {
      var _ref7 = _slicedToArray(_ref6, 2),
        columnIndex = _ref7[0],
        quickFilter = _ref7[1];
      var text = quickFilter.text;
      return [columnIndex, {
        text
      }];
    });
  }
  static dehydrateLong(value) {
    return value != null ? "".concat(value) : null;
  }

  /**
   * Export the sorts from the provided table sorts to JSON stringifiable object
   * @param  sorts The table sorts
   * @returns The dehydrated sorts
   */
  static dehydrateSort(sorts) {
    return sorts.map(sort => {
      var column = sort.column,
        isAbs = sort.isAbs,
        direction = sort.direction;
      return {
        column: column.name,
        isAbs,
        direction
      };
    });
  }

  /**
   * Pulls just the table settings from the panel state, eg. filters/sorts
   * @param  panelState The dehydrated panel state
   * @returns A dehydrated table settings object, { partition, partitionColumn, advancedFilters, quickFilters, sorts }
   */
  static extractTableSettings(panelState) {
    var inputFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var irisGridPanelState = panelState.irisGridPanelState,
      irisGridState = panelState.irisGridState;
    var partitions = isPanelStateV2(irisGridPanelState) ? irisGridPanelState.partitions : [irisGridPanelState.partition];
    var advancedFilters = irisGridState.advancedFilters,
      quickFilters = irisGridState.quickFilters,
      sorts = irisGridState.sorts;
    return {
      advancedFilters,
      inputFilters,
      partitions,
      quickFilters,
      sorts
    };
  }
  static getInputFiltersForColumns(columns) {
    var inputFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return inputFilters.filter(_ref8 => {
      var name = _ref8.name,
        type = _ref8.type;
      return columns.find(_ref9 => {
        var columnName = _ref9.name,
          columnType = _ref9.type;
        return columnName === name && columnType === type;
      });
    });
  }
  static getFiltersFromFilterMap(filterMap) {
    var filters = [];
    var keys = Array.from(filterMap.keys());
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var item = filterMap.get(key);
      if ((item === null || item === void 0 ? void 0 : item.filter) != null) {
        filters.push(item.filter);
      }
    }
    return filters;
  }

  /**
   * Get array of hidden column indexes
   * @param  userColumnWidths Map of user column widths
   * @returns Array of hidden column indexes
   */
  static getHiddenColumns(userColumnWidths) {
    return [...userColumnWidths.entries()].filter(_ref0 => {
      var _ref1 = _slicedToArray(_ref0, 2),
        value = _ref1[1];
      return value === 0;
    }).map(_ref10 => {
      var _ref11 = _slicedToArray(_ref10, 1),
        key = _ref11[0];
      return key;
    });
  }
  static parseCustomColumnNames(customColumns) {
    return customColumns.map(customColumn => customColumn.split('=')[0]);
  }
  static getRemovedCustomColumnNames(oldCustomColumns, customColumns) {
    var oldCustomColumnsNames = IrisGridUtils.parseCustomColumnNames(oldCustomColumns);
    var customColumnNames = IrisGridUtils.parseCustomColumnNames(customColumns);
    return oldCustomColumnsNames.filter(oldCustomColumnName => !customColumnNames.includes(oldCustomColumnName));
  }
  static removeSortsInColumns(sorts, columnNames) {
    return sorts.filter(sort => !columnNames.includes(sort.column.name));
  }
  static removeFiltersInColumns(columns, filters, removedColumnNames) {
    var columnNames = columns.map(_ref12 => {
      var name = _ref12.name;
      return name;
    });
    var newFilter = new Map(filters);
    removedColumnNames.forEach(columnName => newFilter.delete(columnNames.indexOf(columnName)));
    return newFilter;
  }
  static removeColumnFromMovedColumns(columns, movedColumns, removedColumnNames) {
    var columnNames = columns.map(_ref13 => {
      var name = _ref13.name;
      return name;
    });
    var newMoves = [...movedColumns];
    var _loop = function _loop() {
      var removedColumnName = removedColumnNames[i];
      var removedColumnIndex = columnNames.findIndex(name => name === removedColumnName);
      var moves = [];
      for (var j = 0; j < newMoves.length; j += 1) {
        var move = newMoves[j];
        var newMove = _objectSpread({}, move);
        var _ref14 = Array.isArray(move.from) ? move.from : [move.from, move.from],
          _ref15 = _slicedToArray(_ref14, 2),
          fromStart = _ref15[0],
          fromEnd = _ref15[1];
        if (removedColumnIndex <= move.to) {
          newMove.to -= 1;
        }

        // If equal to fromStart, the new fromStart would stay the same
        // It's just the next element in the range which will have the same index after deletion
        if (removedColumnIndex < fromStart) {
          fromStart -= 1;
        }
        if (removedColumnIndex <= fromEnd) {
          fromEnd -= 1;
        }
        if (fromStart <= fromEnd && fromStart !== newMove.to) {
          if (fromStart === fromEnd) {
            moves.push(_objectSpread(_objectSpread({}, newMove), {}, {
              from: fromStart
            }));
          } else {
            moves.push(_objectSpread(_objectSpread({}, newMove), {}, {
              from: [fromStart, fromEnd]
            }));
          }
        }

        // get the next index of the removed column after the move is applied
        // eslint-disable-next-line prefer-destructuring
        removedColumnIndex = GridUtils.applyItemMoves(removedColumnIndex, removedColumnIndex, [move])[0][0];
      }
      newMoves = moves;
      columnNames.splice(columnNames.findIndex(name => name === removedColumnName), 1);
    };
    for (var i = 0; i < removedColumnNames.length; i += 1) {
      _loop();
    }
    return newMoves;
  }
  static removeColumnsFromSelectDistinctColumns(selectDistinctColumns, removedColumnNames) {
    return selectDistinctColumns.filter(columnName => !removedColumnNames.includes(columnName));
  }
  static getVisibleColumnsInRange(tableColumns, left, right, movedColumns, hiddenColumns) {
    var columns = [];
    for (var i = left; i <= right; i += 1) {
      var modelIndex = GridUtils.getModelIndex(i, movedColumns);
      if (modelIndex >= 0 && modelIndex < tableColumns.length && !hiddenColumns.includes(modelIndex)) {
        columns.push(tableColumns[modelIndex]);
      }
    }
    return columns;
  }
  static getPrevVisibleColumns(tableColumns, startIndex, count, movedColumns, hiddenColumns) {
    var columns = [];
    var i = startIndex;
    while (i >= 0 && columns.length < count) {
      var modelIndex = GridUtils.getModelIndex(i, movedColumns);
      if (modelIndex >= 0 && modelIndex < tableColumns.length && !hiddenColumns.includes(modelIndex)) {
        columns.unshift(tableColumns[modelIndex]);
      }
      i -= 1;
    }
    return columns;
  }
  static getNextVisibleColumns(tableColumns, startIndex, count, movedColumns, hiddenColumns) {
    var columns = [];
    var i = startIndex;
    while (i < tableColumns.length && columns.length < count) {
      var modelIndex = GridUtils.getModelIndex(i, movedColumns);
      if (modelIndex >= 0 && modelIndex < tableColumns.length && !hiddenColumns.includes(modelIndex)) {
        columns.push(tableColumns[modelIndex]);
      }
      i += 1;
    }
    return columns;
  }
  static getColumnsToFetch(tableColumns, viewportColumns, alwaysFetchColumnNames) {
    var columnsToFetch = [...viewportColumns];
    alwaysFetchColumnNames.forEach(columnName => {
      var column = tableColumns.find(_ref16 => {
        var name = _ref16.name;
        return name === columnName;
      });
      if (column != null && !viewportColumns.includes(column)) {
        columnsToFetch.push(column);
      }
    });
    return columnsToFetch;
  }
  static getModelViewportColumns(columns, left, right, movedColumns) {
    var hiddenColumns = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var alwaysFetchColumnNames = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var bufferPages = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    if (left == null || right == null) {
      return undefined;
    }
    var columnsCenter = IrisGridUtils.getVisibleColumnsInRange(columns, left, right, movedColumns, hiddenColumns);
    var bufferWidth = columnsCenter.length * bufferPages;
    var columnsLeft = IrisGridUtils.getPrevVisibleColumns(columns, left - 1, bufferWidth, movedColumns, hiddenColumns);
    var columnsRight = IrisGridUtils.getNextVisibleColumns(columns, right + 1, bufferWidth, movedColumns, hiddenColumns);
    var bufferedColumns = [...columnsLeft, ...columnsCenter, ...columnsRight];
    return IrisGridUtils.getColumnsToFetch(columns, bufferedColumns, alwaysFetchColumnNames);
  }

  /**
   * Validate whether the ranges passed in are valid to take a snapshot from.
   * Multiple selections are valid if all of the selected rows have the same columns selected.
   *
   * @param ranges The ranges to validate
   * @returns True if the ranges are valid, false otherwise
   */
  static isValidSnapshotRanges(ranges) {
    if (ranges == null || ranges.length === 0) {
      return false;
    }

    // To verify all the rows selected have the same set of columns selected, build a map with string representations
    // of each range.
    var rangeMap = new Map();
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i];
      var rowMapIndex = "".concat(range.startRow, ":").concat(range.endRow);
      var columnMapIndex = "".concat(range.startColumn, ":").concat(range.endColumn);
      if (!rangeMap.has(rowMapIndex)) {
        rangeMap.set(rowMapIndex, []);
      }
      rangeMap.get(rowMapIndex).push(columnMapIndex);
    }
    var keys = [...rangeMap.keys()];
    var matchColumnRanges = rangeMap.get(keys[0]).sort().join(',');
    for (var _i = 1; _i < keys.length; _i += 1) {
      if (rangeMap.get(keys[_i]).sort().join(',') !== matchColumnRanges) {
        return false;
      }
    }
    return true;
  }

  /**
   * Check if the provided value is a valid table index
   * @param  value A value to check if it's a valid table index
   */
  static isValidIndex(value) {
    if (!Number.isInteger(value)) {
      return false;
    }
    if (!(typeof value === 'number')) {
      return false;
    }
    return value >= 0;
  }

  /**
   * Returns all columns used in any of the ranges provided
   * @param  ranges The model ranges to get columns for
   * @param  allColumns All the columns to pull from
   * @returns The columns selected in the range
   */
  static columnsFromRanges(ranges, allColumns) {
    if (ranges == null || ranges.length === 0) {
      return [];
    }
    if (ranges[0].startColumn === null && ranges[0].endColumn === null) {
      // Snapshot of all the columns
      return [...allColumns];
    }
    var columnSet = new Set();
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i];
      assertNotNull(range.startColumn);
      assertNotNull(range.endColumn);
      for (var c = (_range$startColumn = range.startColumn) !== null && _range$startColumn !== void 0 ? _range$startColumn : 0; c <= ((_range$endColumn = range.endColumn) !== null && _range$endColumn !== void 0 ? _range$endColumn : allColumns.length - 1); c += 1) {
        var _range$startColumn, _range$endColumn;
        columnSet.add(c);
      }
    }
    return [...columnSet].map(c => allColumns[c]);
  }

  /**
   * Transforms an iris data snapshot into a simple data matrix
   * @param  data The Iris formatted table data
   * @returns A matrix of the values of the data
   */
  static snapshotDataToMatrix(data) {
    var columns = data.columns,
      rows = data.rows;
    var result = [];
    for (var r = 0; r < rows.length; r += 1) {
      var row = rows[r];
      var rowData = [];
      for (var c = 0; c < columns.length; c += 1) {
        var column = columns[c];
        var value = row.get(column);
        rowData.push(value);
      }
      result.push(rowData);
    }
    return result;
  }

  /**
   * Hydrate model rollup config
   * @param  originalColumns Original model columns
   * @param  config Dehydrated rollup config
   * @param  aggregationSettings Aggregation settings
   * @returns Rollup config for the model
   */
  static getModelRollupConfig(originalColumns, config, aggregationSettings) {
    var _config$columns$lengt, _config$columns;
    if (((_config$columns$lengt = config === null || config === void 0 || (_config$columns = config.columns) === null || _config$columns === void 0 ? void 0 : _config$columns.length) !== null && _config$columns$lengt !== void 0 ? _config$columns$lengt : 0) === 0) {
      return null;
    }
    var _ref17 = config !== null && config !== void 0 ? config : {},
      _ref17$columns = _ref17.columns,
      groupingColumns = _ref17$columns === void 0 ? [] : _ref17$columns,
      _ref17$showConstituen = _ref17.showConstituents,
      includeConstituents = _ref17$showConstituen === void 0 ? true : _ref17$showConstituen,
      _ref17$showNonAggrega = _ref17.showNonAggregatedColumns,
      showNonAggregatedColumns = _ref17$showNonAggrega === void 0 ? true : _ref17$showNonAggrega,
      _ref17$includeDescrip = _ref17.includeDescriptions,
      includeDescriptions = _ref17$includeDescrip === void 0 ? true : _ref17$includeDescrip;
    var _ref18 = aggregationSettings !== null && aggregationSettings !== void 0 ? aggregationSettings : {},
      _ref18$aggregations = _ref18.aggregations,
      aggregations = _ref18$aggregations === void 0 ? [] : _ref18$aggregations;
    var filteredAggregations = aggregations.filter(_ref19 => {
      var operation = _ref19.operation;
      return !AggregationUtils.isRollupProhibited(operation);
    });
    var aggregationColumns = filteredAggregations.map(_ref20 => {
      var operation = _ref20.operation,
        selected = _ref20.selected,
        invert = _ref20.invert;
      return AggregationUtils.isRollupOperation(operation) ? [] : AggregationUtils.getOperationColumnNames(originalColumns, operation, selected, invert);
    });
    var aggregationMap = {};
    // Aggregation columns should show first, add them first
    for (var i = 0; i < filteredAggregations.length; i += 1) {
      aggregationMap[filteredAggregations[i].operation] = aggregationColumns[i];
    }
    if (showNonAggregatedColumns) {
      // Filter out any column that already has an aggregation or grouping
      var nonAggregatedColumnSet = new Set(originalColumns.map(c => c.name).filter(name => !groupingColumns.includes(name)));
      aggregationColumns.forEach(columns => {
        columns.forEach(name => nonAggregatedColumnSet.delete(name));
      });
      if (nonAggregatedColumnSet.size > 0) {
        var _aggregationMap$Aggre;
        var existingColumns = (_aggregationMap$Aggre = aggregationMap[AggregationOperation.FIRST]) !== null && _aggregationMap$Aggre !== void 0 ? _aggregationMap$Aggre : [];
        aggregationMap[AggregationOperation.FIRST] = [...existingColumns, ...nonAggregatedColumnSet];
      }
    }
    return {
      groupingColumns,
      includeConstituents,
      includeDescriptions,
      aggregations: aggregationMap
    };
  }

  /**
   * Build a per-column aggregation operation map for use in a
   * `UITotalsTableConfig`. Rollup-only operations are skipped.
   */
  static getOperationMap(columns, aggregations) {
    var operationMap = {};
    aggregations.filter(a => !AggregationUtils.isRollupOperation(a.operation)).forEach(_ref21 => {
      var operation = _ref21.operation,
        selected = _ref21.selected,
        invert = _ref21.invert;
      AggregationUtils.getOperationColumnNames(columns, operation, selected, invert).forEach(name => {
        var _operationMap$name;
        var newOperations = [...((_operationMap$name = operationMap[name]) !== null && _operationMap$name !== void 0 ? _operationMap$name : []), operation];
        operationMap[name] = Object.freeze(newOperations);
      });
    });
    return operationMap;
  }

  /**
   * Ordered list of (non-rollup) operations used by a totals table.
   */
  static getOperationOrder(aggregations) {
    return aggregations.map(a => a.operation).filter(o => !AggregationUtils.isRollupOperation(o));
  }

  /**
   * Hydrate model totals config for a standalone aggregations view
   * (no rollup). Returns `null` when there are no active aggregations
   * or when a rollup is active (in which case aggregations are folded
   * into the rollup config instead — see `getModelRollupConfig`).
   *
   * @param  columns Model columns
   * @param  rollupConfig Current rollup config (or undefined). When set
   *                     with at least one grouping column, this returns
   *                     `null` so totals don't double-up with the rollup.
   * @param  aggregationSettings Aggregation settings
   */
  static getModelTotalsConfig(columns, rollupConfig, aggregationSettings) {
    var _rollupConfig$columns, _rollupConfig$columns2;
    if (((_rollupConfig$columns = rollupConfig === null || rollupConfig === void 0 || (_rollupConfig$columns2 = rollupConfig.columns) === null || _rollupConfig$columns2 === void 0 ? void 0 : _rollupConfig$columns2.length) !== null && _rollupConfig$columns !== void 0 ? _rollupConfig$columns : 0) > 0) {
      return null;
    }
    var aggregations = aggregationSettings.aggregations.filter(agg => agg.selected.length > 0 || agg.invert);
    if (aggregations.length === 0) {
      return null;
    }
    return {
      operationMap: IrisGridUtils.getOperationMap(columns, aggregations),
      operationOrder: IrisGridUtils.getOperationOrder(aggregations),
      showOnTop: aggregationSettings.showOnTop,
      defaultOperation: AggregationOperation.SKIP
    };
  }

  /**
   * Returns true when all rollback-tracked config fields are at their default
   * (empty) values, meaning there is no meaningful state to save or restore.
   */
  static isEmptyConfig(_ref22) {
    var advancedFilters = _ref22.advancedFilters,
      aggregationSettings = _ref22.aggregationSettings,
      conditionalFormats = _ref22.conditionalFormats,
      customColumns = _ref22.customColumns,
      quickFilters = _ref22.quickFilters,
      reverse = _ref22.reverse,
      rollupConfig = _ref22.rollupConfig,
      searchFilter = _ref22.searchFilter,
      selectDistinctColumns = _ref22.selectDistinctColumns,
      sorts = _ref22.sorts;
    return advancedFilters.size === 0 && aggregationSettings.aggregations.length === 0 && conditionalFormats.length === 0 && customColumns.length === 0 && quickFilters.size === 0 && !reverse && rollupConfig == null && searchFilter == null && selectDistinctColumns.length === 0 && sorts.length === 0;
  }

  /**
   * @param  pendingDataMap Map of pending data
   * @returns A map with the errors in the pending data
   */
  static getPendingErrors(pendingDataMap) {
    pendingDataMap.forEach((row, rowIndex) => {
      if (!IrisGridUtils.isValidIndex(rowIndex)) {
        throw new Error("Invalid rowIndex ".concat(rowIndex));
      }
      var data = row.data;
      data.forEach((value, columnIndex) => {
        if (!IrisGridUtils.isValidIndex(columnIndex)) {
          throw new Error("Invalid columnIndex ".concat(columnIndex));
        }
      });
    });
  }

  /**
   * Retrieves a column from the provided array at the index, or `null` and logs an error if it's invalid
   *
   * @param  columns The columns to get the column from
   * @param  columnIndex The column index to get
   */
  static getColumn(columns, columnIndex) {
    if (columnIndex < columns.length) {
      return columns[columnIndex];
    }
    log.error('Unable to retrieve column', columnIndex, '>=', columns.length);
    return null;
  }

  /**
   * Retrieves a column from the provided array matching the name, or `null` and logs an error if not found
   * @param  columns The columns to get the column from
   * @param  columnName The column name to retrieve
   */
  static getColumnByName(columns, columnName) {
    // Columns can contain ColumnBy sources with negative indexes
    var column = Object.values(columns).find(_ref23 => {
      var name = _ref23.name;
      return name === columnName;
    });
    if (column == null) {
      log.error('Unable to retrieve column by name', columnName, columns.map(_ref24 => {
        var name = _ref24.name;
        return name;
      }));
    }
    return column;
  }

  /**
   * Get filter configs with column names changed to indexes, exclude missing columns
   * @param  columns The columns to get column indexes from
   * @param  filters Filter configs
   * @returns Updated filter configs with column names changed to indexes
   */
  static changeFilterColumnNamesToIndexes(columns, filters) {
    return filters.map(_ref25 => {
      var name = _ref25.name,
        filter = _ref25.filter;
      var index = columns.findIndex(column => column.name === name);
      return index < 0 ? null : [index, filter];
    }).filter(filterConfig => filterConfig != null);
  }

  /**
   * @param columnType The column type that the filters will be applied to.
   * @param filterList The list of filters to be combined.
   * @returns The combination of the filters in filterList as text.
   */
  static combineFiltersFromList(columnType, filterList) {
    filterList.sort((a, b) => {
      // move all 'equals' comparisons to end of list
      if (a.operator === 'eq' && b.operator !== 'eq') {
        return 1;
      }
      if (a.operator !== 'eq' && b.operator === 'eq') {
        return -1;
      }
      return a.startColumnIndex - b.startColumnIndex;
    });
    var combinedText = '';
    for (var i = 0; i < filterList.length; i += 1) {
      var _filterList$i = filterList[i],
        text = _filterList$i.text,
        value = _filterList$i.value,
        operator = _filterList$i.operator;
      if (value !== undefined) {
        var symbol = '';
        if (operator !== undefined) {
          if (value == null && operator === 'eq') {
            symbol = '=';
          } else if (operator !== 'eq') {
            if (operator === 'startsWith' || operator === 'endsWith') {
              symbol = '*';
            } else {
              symbol = TableUtils.getFilterOperatorString(operator);
            }
          }
        }
        var filterText = "".concat(symbol).concat(text);
        if (operator === 'startsWith') {
          filterText = "".concat(text).concat(symbol);
        }
        if (columnType != null && value !== null && TableUtils.isCharType(columnType)) {
          filterText = "".concat(symbol).concat(String.fromCharCode(parseInt(text, 10)));
        }
        if (i !== 0) {
          combinedText += operator === 'eq' ? ' || ' : ' && ';
        }
        combinedText += filterText;
      }
    }
    return combinedText;
  }

  /**
   * Parses the column header groups provided.
   * If undefined, should provide default groups such as from layoutHints
   *
   * @returns Object containing groups array, max depth, map of name to parent group, and map of name to group
   */
  static parseColumnHeaderGroups(model, groupsParam) {
    var makeColumnHeaderGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : args => new ColumnHeaderGroup(args);
    var maxDepth = 1;
    var parentMap = new Map();
    var groupMap = new Map();

    // Remove any empty groups before parsing
    var groups = groupsParam === null || groupsParam === void 0 ? void 0 : groupsParam.filter(_ref26 => {
      var children = _ref26.children;
      return children != null && children.length > 0;
    });
    if (groups.length === 0) {
      return {
        groups: [],
        maxDepth,
        parentMap,
        groupMap
      };
    }
    var originalGroupMap = new Map(groups.map(group => [group.name, group]));
    var seenChildren = new Set();
    var addGroup = group => {
      var _group$children;
      var name = group.name;
      assertNotNull(name, 'Column header group has no name');
      var columnIndex = model.getColumnIndexByName(name);
      // Groups cannot have names matching columns to avoid parent-child collision
      // unless they refer to ColumnBy sources with negative indexes
      if (columnIndex != null && columnIndex >= 0) {
        throw new Error("Column header group has same name as column: ".concat(name));
      }
      var existingGroup = groupMap.get(name);
      if (existingGroup) {
        return existingGroup;
      }
      var childIndexes = [];
      var depth = 1;
      if (group.children == null) {
        throw new Error("Column header group ".concat(name, " has no children"));
      }
      group.children.forEach(childName => {
        if (seenChildren.has(childName)) {
          throw new Error("Column group child ".concat(childName, " specified in multiple groups"));
        }
        seenChildren.add(childName);
        var childGroup = originalGroupMap.get(childName);
        var childIndex = model.getColumnIndexByName(childName);
        if (childGroup) {
          // Adding another column header group
          var addedGroup = addGroup(childGroup);
          childIndexes.push(...addedGroup.childIndexes);
          depth = Math.max(depth, addedGroup.depth + 1);
        } else if (childIndex != null) {
          // Adding a base column
          childIndexes.push(childIndex);
          depth = Math.max(depth, 1);
        } else {
          throw new Error("Unknown child ".concat(childName, " in group ").concat(name));
        }
      });
      var headerGroupConfig = _objectSpread(_objectSpread({}, group), {}, {
        name,
        children: group.children,
        depth,
        childIndexes: childIndexes.flat()
      });
      var columnHeaderGroup = makeColumnHeaderGroup(headerGroupConfig);
      groupMap.set(name, columnHeaderGroup);
      (_group$children = group.children) === null || _group$children === void 0 || _group$children.forEach(childName => parentMap.set(childName, columnHeaderGroup));
      maxDepth = Math.max(maxDepth, columnHeaderGroup.depth + 1);
      return columnHeaderGroup;
    };
    var groupNames = new Set();
    groups.forEach(group => {
      var name = group.name;
      if (groupNames.has(name)) {
        throw new Error("Duplicate column group name: ".concat(name));
      }
      groupNames.add(name);
      addGroup(group);
    });
    groupMap.forEach(group => {
      var _parentMap$get;
      group.setParent((_parentMap$get = parentMap.get(group.name)) === null || _parentMap$get === void 0 ? void 0 : _parentMap$get.name);
    });
    return {
      groups: [...groupMap.values()],
      maxDepth,
      groupMap,
      parentMap
    };
  }

  /**
   * @param value The value of the cell in a column
   * @param columnType The type of the column
   * @returns The value of the cell converted to text
   */
  static convertValueToText(value, columnType) {
    if (columnType != null && TableUtils.isCharType(columnType) && value != null && typeof value === 'number') {
      return String.fromCharCode(value);
    }
    if (TableUtils.isDateType(columnType) && isDateWrapper(value)) {
      var date = new Date(value.asDate());
      var offset = date.getTimezoneOffset();
      var offsetDate = new Date(date.getTime() - offset * 60 * 1000);
      var dateText = offsetDate.toISOString();
      var formattedText = dateText.replace('T', ' ').substring(0, 23);
      return formattedText;
    }
    if (value == null) {
      return '';
    }
    return "".concat(value);
  }
  constructor(dh) {
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "tableUtils", void 0);
    this.dh = dh;
    this.tableUtils = new TableUtils(dh);
    bindAllMethods(this);
  }

  /**
   * Exports the state from IrisGrid to a JSON stringifiable object.
   * See IrisGridCacheUtil for memoization and comparing dehydrated states.
   * @param model The table model to export the state for
   * @param irisGridState The current state of the IrisGrid
   */
  dehydrateIrisGridState(model, irisGridState) {
    var _irisGridState$aggreg = irisGridState.aggregationSettings,
      aggregationSettings = _irisGridState$aggreg === void 0 ? {
        aggregations: EMPTY_ARRAY,
        showOnTop: false
      } : _irisGridState$aggreg,
      advancedFilters = irisGridState.advancedFilters,
      customColumnFormatMap = irisGridState.customColumnFormatMap,
      _irisGridState$column = irisGridState.columnAlignmentMap,
      columnAlignmentMap = _irisGridState$column === void 0 ? EMPTY_MAP : _irisGridState$column,
      isFilterBarShown = irisGridState.isFilterBarShown,
      metricCalculator = irisGridState.metricCalculator,
      _irisGridState$metric = irisGridState.metrics,
      _irisGridState$metric2 = _irisGridState$metric === void 0 ? {} : _irisGridState$metric,
      _irisGridState$metric3 = _irisGridState$metric2.userColumnWidths,
      userColumnWidths = _irisGridState$metric3 === void 0 ? new Map() : _irisGridState$metric3,
      _irisGridState$metric4 = _irisGridState$metric2.userRowHeights,
      userRowHeights = _irisGridState$metric4 === void 0 ? new Map() : _irisGridState$metric4,
      quickFilters = irisGridState.quickFilters,
      customColumns = irisGridState.customColumns,
      _irisGridState$condit = irisGridState.conditionalFormats,
      conditionalFormats = _irisGridState$condit === void 0 ? EMPTY_ARRAY : _irisGridState$condit,
      reverse = irisGridState.reverse,
      rollupConfig = irisGridState.rollupConfig,
      showSearchBar = irisGridState.showSearchBar,
      searchValue = irisGridState.searchValue,
      _irisGridState$select = irisGridState.selectDistinctColumns,
      selectDistinctColumns = _irisGridState$select === void 0 ? EMPTY_ARRAY : _irisGridState$select,
      selectedSearchColumns = irisGridState.selectedSearchColumns,
      sorts = irisGridState.sorts,
      invertSearchColumns = irisGridState.invertSearchColumns,
      _irisGridState$pendin = irisGridState.pendingDataMap,
      pendingDataMap = _irisGridState$pendin === void 0 ? EMPTY_MAP : _irisGridState$pendin,
      frozenColumns = irisGridState.frozenColumns,
      columnHeaderGroups = irisGridState.columnHeaderGroups,
      partitionConfig = irisGridState.partitionConfig;
    var columns = model.columns;
    var partitionColumns = isPartitionedGridModelProvider(model) ? model.partitionColumns : [];

    // Prefer the by-name map from the metric calculator: it preserves entries
    // for columns absent from the current model (e.g. while a rollup is
    // active), so reload-then-save round-trips don't drop them.
    // Fall back to projecting the by-index map from `metrics` against the
    // current model for callers that didn't pass a metric calculator.
    var dehydratedUserColumnWidths = metricCalculator != null ? [...metricCalculator.getUserColumnWidthsByName()] : [...userColumnWidths].filter(_ref27 => {
      var _ref28 = _slicedToArray(_ref27, 1),
        columnIndex = _ref28[0];
      return columnIndex != null && columnIndex >= 0 && columnIndex < columns.length;
    }).map(_ref29 => {
      var _ref30 = _slicedToArray(_ref29, 2),
        columnIndex = _ref30[0],
        width = _ref30[1];
      return [columns[columnIndex].name, width];
    });

    // Return value will be serialized, should not contain undefined
    return {
      advancedFilters: this.dehydrateAdvancedFilters(columns, advancedFilters),
      aggregationSettings,
      customColumnFormatMap: [...customColumnFormatMap],
      columnAlignmentMap: [...columnAlignmentMap],
      isFilterBarShown,
      quickFilters: IrisGridUtils.dehydrateQuickFilters(quickFilters),
      sorts: IrisGridUtils.dehydrateSort(sorts),
      userColumnWidths: dehydratedUserColumnWidths,
      userRowHeights: [...userRowHeights],
      customColumns: [...customColumns],
      conditionalFormats: [...conditionalFormats],
      reverse,
      rollupConfig,
      showSearchBar,
      searchValue,
      selectDistinctColumns: [...selectDistinctColumns],
      selectedSearchColumns,
      invertSearchColumns,
      pendingDataMap: this.dehydratePendingDataMap(columns, pendingDataMap),
      frozenColumns,
      columnHeaderGroups: columnHeaderGroups === null || columnHeaderGroups === void 0 ? void 0 : columnHeaderGroups.map(item => {
        var _item$color;
        return {
          name: item.name,
          children: item.children,
          color: (_item$color = item.color) !== null && _item$color !== void 0 ? _item$color : null
        };
      }),
      partitionConfig: this.dehydratePartitionConfig(partitionColumns, partitionConfig)
    };
  }

  /**
   * Migrates a single conditional formatting rule saved in the old format
   * (`column`/`value`) to the current format (`leftHandValue`/`rightHandValue`/
   * `formattedColumns`). Rules already in the current format are returned
   * unchanged.
   */
  static migrateConditionalFormattingRule(rule) {
    var rawConfig = rule.config;
    if ('column' in rawConfig && !('leftHandValue' in rawConfig)) {
      var oldColumn = rawConfig.column,
        oldValue = rawConfig.value,
        restConfig = _objectWithoutProperties(rawConfig, _excluded);
      var column = oldColumn;
      return _objectSpread(_objectSpread({}, rule), {}, {
        config: _objectSpread(_objectSpread({}, restConfig), {}, {
          leftHandValue: column,
          formattedColumns: rule.type === FormatterType.CONDITIONAL ? [column] : [],
          rightHandValue: oldValue
        })
      });
    }
    return rule;
  }

  /**
   * Import a state for IrisGrid that was exported with {{@link dehydrateIrisGridState}}
   * @param model The table model to import the state with
   * @param irisGridState The saved IrisGrid state
   */
  hydrateIrisGridState(model, irisGridState) {
    var _ref37, _model$layoutHints;
    var advancedFilters = irisGridState.advancedFilters,
      _irisGridState$aggreg2 = irisGridState.aggregationSettings,
      aggregationSettings = _irisGridState$aggreg2 === void 0 ? {
        aggregations: [],
        showOnTop: false
      } : _irisGridState$aggreg2,
      customColumnFormatMap = irisGridState.customColumnFormatMap,
      _irisGridState$column2 = irisGridState.columnAlignmentMap,
      columnAlignmentMap = _irisGridState$column2 === void 0 ? [] : _irisGridState$column2,
      isFilterBarShown = irisGridState.isFilterBarShown,
      quickFilters = irisGridState.quickFilters,
      sorts = irisGridState.sorts,
      customColumns = irisGridState.customColumns,
      conditionalFormats = irisGridState.conditionalFormats,
      userColumnWidths = irisGridState.userColumnWidths,
      userRowHeights = irisGridState.userRowHeights,
      reverseType = irisGridState.reverseType,
      reverse = irisGridState.reverse,
      _irisGridState$rollup = irisGridState.rollupConfig,
      rollupConfig = _irisGridState$rollup === void 0 ? undefined : _irisGridState$rollup,
      showSearchBar = irisGridState.showSearchBar,
      searchValue = irisGridState.searchValue,
      selectDistinctColumns = irisGridState.selectDistinctColumns,
      selectedSearchColumns = irisGridState.selectedSearchColumns,
      _irisGridState$invert = irisGridState.invertSearchColumns,
      invertSearchColumns = _irisGridState$invert === void 0 ? true : _irisGridState$invert,
      _irisGridState$pendin2 = irisGridState.pendingDataMap,
      pendingDataMap = _irisGridState$pendin2 === void 0 ? [] : _irisGridState$pendin2,
      frozenColumns = irisGridState.frozenColumns,
      columnHeaderGroups = irisGridState.columnHeaderGroups,
      partitionConfig = irisGridState.partitionConfig;
    var columns = model.columns,
      formatter = model.formatter;
    var partitionColumns = isPartitionedGridModelProvider(model) ? model.partitionColumns : [];

    // Build a name-keyed map preserving every persisted entry, including
    // entries for columns absent from the current model. Then derive the
    // by-index map from that for back-compat with consumers that read
    // widths immediately after hydrate.
    var userColumnWidthsByName = new Map();
    userColumnWidths.forEach(_ref31 => {
      var _columns;
      var _ref32 = _slicedToArray(_ref31, 2),
        column = _ref32[0],
        width = _ref32[1];
      var name = typeof column === 'string' || column instanceof String ? column : (_columns = columns[column]) === null || _columns === void 0 ? void 0 : _columns.name;
      if (name != null) {
        userColumnWidthsByName.set(name, width);
      }
    });
    return {
      advancedFilters: this.hydrateAdvancedFilters(columns, advancedFilters, formatter.timeZone),
      aggregationSettings,
      customColumnFormatMap: new Map(customColumnFormatMap),
      columnAlignmentMap: new Map(columnAlignmentMap),
      isFilterBarShown,
      quickFilters: this.hydrateQuickFilters(columns, quickFilters, formatter.timeZone),
      sorts: this.hydrateSort(columns, sorts, true),
      userColumnWidthsByName,
      userColumnWidths: new Map([...userColumnWidthsByName].map(_ref33 => {
        var _ref34 = _slicedToArray(_ref33, 2),
          name = _ref34[0],
          width = _ref34[1];
        return [columns.findIndex(c => c.name === name), width];
      }).filter(_ref35 => {
        var _ref36 = _slicedToArray(_ref35, 1),
          column = _ref36[0];
        return column != null && column >= 0 && column < columns.length;
      })),
      customColumns,
      conditionalFormats: (conditionalFormats !== null && conditionalFormats !== void 0 ? conditionalFormats : []).map(IrisGridUtils.migrateConditionalFormattingRule),
      userRowHeights: new Map(userRowHeights),
      reverse: reverseType === TableUtils.REVERSE_TYPE.POST_SORT || reverse,
      rollupConfig,
      showSearchBar,
      searchValue,
      selectDistinctColumns,
      selectedSearchColumns,
      invertSearchColumns,
      pendingDataMap: this.hydratePendingDataMap(columns, pendingDataMap),
      frozenColumns,
      columnHeaderGroups: IrisGridUtils.parseColumnHeaderGroups(model, (_ref37 = columnHeaderGroups !== null && columnHeaderGroups !== void 0 ? columnHeaderGroups : (_model$layoutHints = model.layoutHints) === null || _model$layoutHints === void 0 ? void 0 : _model$layoutHints.columnGroups) !== null && _ref37 !== void 0 ? _ref37 : []).groups,
      partitionConfig: this.hydratePartitionConfig(partitionColumns, partitionConfig)
    };
  }

  /**
   * Import the saved quick filters to apply to the columns. Does not actually apply the filters.
   * @param  columns The columns the filters will be applied to
   * @param  savedQuickFilters Exported quick filters definitions
   * @param  timeZone The time zone to make this value in if it is a date type. E.g. America/New_York
   * @returns The quick filters to apply to the columns
   */
  hydrateQuickFilters(columns, savedQuickFilters, timeZone) {
    var importedFilters = savedQuickFilters.map(_ref38 => {
      var _ref39 = _slicedToArray(_ref38, 2),
        columnIndex = _ref39[0],
        quickFilter = _ref39[1];
      var text = quickFilter.text;
      var filter = null;
      try {
        var column = IrisGridUtils.getColumn(columns, columnIndex);
        if (column != null) {
          filter = this.tableUtils.makeQuickFilter(column, text, timeZone);
        }
      } catch (error) {
        log.error('hydrateQuickFilters error with', text, error);
      }
      return [columnIndex, {
        text,
        filter
      }];
    });
    return new Map(importedFilters);
  }

  /**
   * Export the advanced filters from the provided columns to JSON striginfiable object
   * @param columns The columns for the filters
   * @param advancedFilters The advanced filters to dehydrate
   * @returns The dehydrated advanced filters
   */
  dehydrateAdvancedFilters(columns, advancedFilters) {
    return [...advancedFilters].map(_ref40 => {
      var _ref41 = _slicedToArray(_ref40, 2),
        columnIndex = _ref41[0],
        advancedFilter = _ref41[1];
      var column = IrisGridUtils.getColumn(columns, columnIndex);
      assertNotNull(column);
      var options = this.dehydrateAdvancedFilterOptions(column, advancedFilter.options);
      return [columnIndex, {
        options
      }];
    });
  }

  /**
   * Import the saved advanced filters to apply to the columns. Does not actually apply the filters.
   * @param  columns The columns the filters will be applied to
   * @param  savedAdvancedFilters Exported advanced filters definitions
   * @param  timeZone The time zone to make this filter in if it is a date type. E.g. America/New_York
   * @returns The advanced filters to apply to the columns
   */
  hydrateAdvancedFilters(columns, savedAdvancedFilters, timeZone) {
    var importedFilters = savedAdvancedFilters.map(_ref42 => {
      var _ref43 = _slicedToArray(_ref42, 2),
        columnIndex = _ref43[0],
        advancedFilter = _ref43[1];
      var column = IrisGridUtils.getColumn(columns, columnIndex);
      assertNotNull(column);
      var options = this.hydrateAdvancedFilterOptions(column, advancedFilter.options);
      var filter = null;
      try {
        var columnRetrieved = IrisGridUtils.getColumn(columns, columnIndex);
        if (columnRetrieved != null) {
          filter = this.tableUtils.makeAdvancedFilter(column, options, timeZone);
        }
      } catch (error) {
        log.error('hydrateAdvancedFilters error with', options, error);
      }
      return [columnIndex, {
        options,
        filter
      }];
    });
    return new Map(importedFilters);
  }
  dehydrateAdvancedFilterOptions(column, options) {
    var selectedValues = options.selectedValues,
      otherOptions = _objectWithoutProperties(options, _excluded2);
    return _objectSpread({
      selectedValues: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(value => this.dehydrateValue(value, column === null || column === void 0 ? void 0 : column.type))
    }, otherOptions);
  }
  hydrateAdvancedFilterOptions(column, options) {
    var selectedValues = options.selectedValues,
      otherOptions = _objectWithoutProperties(options, _excluded3);
    return _objectSpread({
      selectedValues: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(value => this.hydrateValue(value, column === null || column === void 0 ? void 0 : column.type))
    }, otherOptions);
  }
  dehydratePendingDataMap(columns, pendingDataMap) {
    return [...pendingDataMap].map(_ref44 => {
      var _ref45 = _slicedToArray(_ref44, 2),
        rowIndex = _ref45[0],
        data = _ref45[1].data;
      return [rowIndex, {
        data: [...data].filter(_ref46 => {
          var _ref47 = _slicedToArray(_ref46, 1),
            c = _ref47[0];
          return typeof c === 'number';
        }).map(_ref48 => {
          var _ref49 = _slicedToArray(_ref48, 2),
            c = _ref49[0],
            cellData = _ref49[1];
          return [columns[c].name, this.dehydrateValue(cellData.value, columns[c].type)];
        })
      }];
    });
  }
  hydratePendingDataMap(columns, pendingDataMap) {
    var columnMap = new Map();
    var getColumnIndex = columnName => {
      if (!columnMap.has(columnName)) {
        columnMap.set(columnName, columns.findIndex(_ref50 => {
          var name = _ref50.name;
          return name === columnName;
        }));
      }
      return columnMap.get(columnName);
    };
    return new Map(pendingDataMap.map(_ref51 => {
      var _ref52 = _slicedToArray(_ref51, 2),
        rowIndex = _ref52[0],
        data = _ref52[1].data;
      return [rowIndex, {
        data: new Map(data.map(_ref53 => {
          var _getColumnIndex;
          var _ref54 = _slicedToArray(_ref53, 2),
            columnName = _ref54[0],
            value = _ref54[1];
          var index = getColumnIndex(columnName);
          assertNotNull(index);
          return [(_getColumnIndex = getColumnIndex(columnName)) !== null && _getColumnIndex !== void 0 ? _getColumnIndex : null, {
            value: this.hydrateValue(value, columns[index].type)
          }];
        }))
      }];
    }));
  }
  dehydratePartitionConfig(partitionColumns, partitionConfig) {
    if (partitionConfig == null) {
      return partitionConfig;
    }
    return _objectSpread(_objectSpread({}, partitionConfig), {}, {
      partitions: partitionConfig.partitions.map((partition, index) => this.dehydrateValue(partition, partitionColumns[index].type))
    });
  }
  hydratePartitionConfig(partitionColumns, partitionConfig) {
    if (partitionConfig == null) {
      return partitionConfig;
    }
    return _objectSpread(_objectSpread({}, partitionConfig), {}, {
      partitions: partitionConfig.partitions.map((partition, index) => this.hydrateValue(partition, partitionColumns[index].type))
    });
  }

  /**
   * Dehydrates/serializes a value for storage.
   * @param  value The value to dehydrate
   * @param  columnType The column type
   */
  dehydrateValue(value, columnType) {
    if (TableUtils.isDateType(columnType)) {
      return this.dehydrateDateTime(value);
    }
    if (TableUtils.isLongType(columnType)) {
      return IrisGridUtils.dehydrateLong(value);
    }
    return value;
  }

  /**
   * Hydrate a value from it's serialized state
   * @param  value The dehydrated value that needs to be hydrated
   * @param  columnType The type of column
   */
  hydrateValue(value, columnType) {
    if (TableUtils.isDateType(columnType)) {
      return this.hydrateDateTime(value);
    }
    if (TableUtils.isLongType(columnType)) {
      return this.hydrateLong(value);
    }
    return value;
  }
  dehydrateDateTime(value) {
    return value != null ? this.dh.i18n.DateTimeFormat.format(DateUtils.FULL_DATE_FORMAT, value) : null;
  }
  hydrateDateTime(value) {
    return value != null ? this.dh.i18n.DateTimeFormat.parse(DateUtils.FULL_DATE_FORMAT, value) : null;
  }
  hydrateLong(value) {
    return value != null ? this.dh.LongWrapper.ofString(value) : null;
  }

  /**
   * Import the saved sorts to apply to the model. Does not actually apply the sort.
   * @param columns The columns the sorts will be applied to
   * @param sorts Exported sort definitions
   * @param dropReverse If true, drop reverse sort descriptors from the result
   * @returns The sort descriptors to apply to the model
   */
  hydrateSort(columns, sorts) {
    var dropReverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var dh = this.dh;
    return sorts.map(sort => {
      var columnIndexOrName = sort.column,
        isAbs = sort.isAbs,
        direction = sort.direction;
      if (direction === TableUtils.sortDirection.reverse) {
        return dh.Table.reverse();
      }
      var column = typeof columnIndexOrName === 'string' ? IrisGridUtils.getColumnByName(columns, columnIndexOrName) : IrisGridUtils.getColumn(columns, columnIndexOrName);
      if (column != null) {
        return {
          column: {
            name: column.name,
            type: column.type
          },
          isAbs,
          direction
        };
      }
      return null;
    })
    // If we can't find the column any more, it's null, filter it out
    // If the item is a reverse sort item, and dropReverse is true, filter it out
    // - it will get applied with the `reverse` property
    // This should only happen when loading a legacy dashboard
    .filter(item => item != null && (item.direction !== TableUtils.sortDirection.reverse || !dropReverse));
  }
  hydrateDhSort(columns, sorts) {
    var dh = this.dh;
    return sorts.map(sortDescriptor => {
      var name = sortDescriptor.column.name,
        isAbs = sortDescriptor.isAbs,
        direction = sortDescriptor.direction;
      if (direction === TableUtils.sortDirection.reverse) {
        return dh.Table.reverse();
      }
      var column = IrisGridUtils.getColumnByName(columns, name);
      if (column != null) {
        var columnSort = column.sort();
        if (isAbs) {
          columnSort = columnSort.abs();
        }
        if (direction === TableUtils.sortDirection.descending) {
          columnSort = columnSort.desc();
        } else {
          columnSort = columnSort.asc();
        }
        return columnSort;
      }
      return null;
    })
    // If we can't find the column any more, it's null, filter it out
    .filter(isNotNullOrUndefined);
  }

  /**
   * Applies the passed in table settings directly to the provided table
   * @param  table The table to apply the settings to
   * @param  tableSettings Dehydrated table settings extracted with `extractTableSettings`
   * @param  timeZone The time zone to make this value in if it is a date type. E.g. America/New_York
   */
  applyTableSettings(table, tableSettings, timeZone) {
    var columns = table.columns;
    var quickFilters = [];
    if (tableSettings.quickFilters) {
      quickFilters = IrisGridUtils.getFiltersFromFilterMap(this.hydrateQuickFilters(columns, tableSettings.quickFilters, timeZone));
    }
    var advancedFilters = [];
    if (tableSettings.advancedFilters) {
      advancedFilters = IrisGridUtils.getFiltersFromFilterMap(this.hydrateAdvancedFilters(columns, tableSettings.advancedFilters, timeZone));
    }
    var inputFilters = this.getFiltersFromInputFilters(columns, tableSettings.inputFilters, timeZone);
    var sorts = [];
    if (tableSettings.sorts) {
      sorts = this.hydrateDhSort(columns, this.hydrateSort(columns, tableSettings.sorts));
    }
    var filters = [...quickFilters, ...advancedFilters];
    var partitions = tableSettings.partitions,
      partitionColumnNames = tableSettings.partitionColumns;
    if (partitions && partitions.length && partitionColumnNames && partitionColumnNames !== null && partitionColumnNames !== void 0 && partitionColumnNames.length) {
      var partitionColumns = partitionColumnNames.map(partitionColumnName => IrisGridUtils.getColumnByName(columns, partitionColumnName));
      for (var i = 0; i < partitionColumns.length; i += 1) {
        if (partitionColumns[i] !== undefined && partitions[i] != null) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          var partitionFilter = partitionColumns[i].filter().eq(this.dh.FilterValue.ofString(partitions[i]));
          filters = [partitionFilter, ...filters];
        }
      }
    }
    filters = [...inputFilters, ...filters];
    table.applyFilter(filters);
    table.applySort(sorts);
  }
  getFiltersFromInputFilters(columns) {
    var inputFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var timeZone = arguments.length > 2 ? arguments[2] : undefined;
    return inputFilters.map(_ref55 => {
      var name = _ref55.name,
        type = _ref55.type,
        value = _ref55.value;
      var column = columns.find(_ref56 => {
        var columnName = _ref56.name,
          columnType = _ref56.type;
        return columnName === name && columnType === type;
      });
      if (column) {
        try {
          return this.tableUtils.makeQuickFilter(column, value, timeZone);
        } catch (e) {
          // It may be unable to create it because user hasn't completed their input
          log.debug('Unable to create input filter', e);
        }
      }
      return null;
    }).filter(filter => filter != null);
  }

  /**
   * Get the dh.RangeSet representation of the provided ranges.
   * Ranges are sorted prior to creating the RangeSet. Only the rows are taken into account,
   * RangeSet does not have an option for columns.
   * @param  ranges The ranges to get the range set for
   * @returns The rangeset for the provided ranges
   */
  rangeSetFromRanges(ranges) {
    var dh = this.dh;
    var rangeSets = ranges.slice().sort((a, b) => {
      assertNotNull(a.startRow);
      assertNotNull(b.startRow);
      return a.startRow - b.startRow;
    }).map(range => {
      var startRow = range.startRow,
        endRow = range.endRow;
      assertNotNull(startRow);
      assertNotNull(endRow);
      return dh.RangeSet.ofRange(startRow, endRow);
    });
    return dh.RangeSet.ofRanges(rangeSets);
  }

  /**
   * Get the color for a cell value
   * @param theme The IrisGrid theme
   * @param columnType The type of the column
   * @param columnName The name of the column
   * @param value The value of the cell
   * @returns The color for the cell value
   */
  static colorForValue(theme, columnType, columnName, value) {
    if (TableUtils.isDateType(columnType) || columnName === 'Date') {
      assertNotNull(theme.dateColor);
      return theme.dateColor;
    }
    if (TableUtils.isNumberType(columnType)) {
      if (value > 0) {
        assertNotNull(theme.positiveNumberColor);
        return theme.positiveNumberColor;
      }
      if (value < 0) {
        assertNotNull(theme.negativeNumberColor);
        return theme.negativeNumberColor;
      }
      assertNotNull(theme.zeroNumberColor);
      return theme.zeroNumberColor;
    }
    return theme.textColor;
  }

  /**
   * Determines the text alignment for a cell value
   * @param columnType The type of the column
   * @param columnName The name of the column
   * @returns The text alignment for the cell value
   */
  static textAlignForValue(columnType, columnName) {
    if (TableUtils.isDateType(columnType) || columnName === 'Date') {
      return 'center';
    }
    if (TableUtils.isNumberType(columnType)) {
      return 'right';
    }
    return 'left';
  }
}
export default IrisGridUtils;
//# sourceMappingURL=IrisGridUtils.js.map